import { render, staticRenderFns } from "./OciNotifications.vue?vue&type=template&id=2856fe2c&"
import script from "./OciNotifications.vue?vue&type=script&lang=js&"
export * from "./OciNotifications.vue?vue&type=script&lang=js&"
import style0 from "./OciNotifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports